import React from 'react';
import Div from "@jumbo/shared/Div";
import Link from "@mui/material/Link";
import {ASSET_IMAGES} from "../../utils/constants/paths";


const Logo = ({mini, mode, sx}) => {
    return (
        <Div sx={{display: "inline-flex", ...sx}}>
            <Link href={'/dashboards/misc'}>
                {
                    !mini ?
                        <img src={ mode === "light" ? `${ASSET_IMAGES}/logos/logo.png` : `${ASSET_IMAGES}/logos/logo-white.png`} alt="Esmax Lubricantes" />
                        :
                        <img src={mode === "light" ? `${ASSET_IMAGES}/logos/logo-short.png` : `${ASSET_IMAGES}/logos/logo-short-white.png`} alt="Esmax Lubricantes" />
                }
            </Link>
        </Div>
    );
};

Logo.defaultProps = {
    mode: "light"
};

export default Logo;
